import { z } from "zod";

export const ChecklistServicoLiberacaoCopiaSchema = z.object({
    idChecklistServico: z.number().int().optional(),
    ordem: z.string().nonempty({ message: "A ordem é obrigatória." }),
    descricao: z.string().nonempty({ message: "A descrição é obrigatória." }),
});

export type ChecklistServicoLiberacaoCopiaForm = z.infer<typeof ChecklistServicoLiberacaoCopiaSchema>;

export const defaultChecklistServicoLiberacaoCopiaForm: Partial<ChecklistServicoLiberacaoCopiaForm> = {
    idChecklistServico: undefined,
    ordem: '',
    descricao: '',
};
